import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private lastError: string | null = null;
  private lastErrorTime: number = 0;
  private errorTimeout = 3000;

  constructor(private notificationService: NotificationService) {}

  handle(error: string, log: boolean = false, notify: boolean = false): Observable<never> {

    if (log) {
      this.logError(error);
    }
    if (notify && this.shouldNotify(error)) {
      this.notifyUser(error);
      this.lastError = error;
      this.lastErrorTime = Date.now();
    }
    return throwError(() => new Error(error));
  }

  private logError(error: any): void {
    console.error('An error occurred:', error);
  }

  private notifyUser(errorMsg: string): void {
    this.notificationService.notify(errorMsg, 'danger');
  }

  private shouldNotify(errorMessage: string): boolean {
    const currentTime = Date.now();
    return !(this.lastError === errorMessage && (currentTime - this.lastErrorTime) < this.errorTimeout);

  }
}
